// import AdditionalServices from "../../Components/AdditionalServices/AdditionalServices";
import { Helmet } from 'react-helmet-async'
import Banner from '../../Components/Banner/Banner'
import Booking from '../../Components/Booking/Booking'
import FleetV2 from '../../Components/Fleet/Fleet2'
import Services from '../../Components/Services/Services'
import WhatWeDo from '../../Components/WhatWeDo/WhatWeDo'

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Luxury Chauffeur Service in London | Airport &amp; Corporate Transfers</title>
        <meta name="description" content="Premium luxury chauffeur service in London offering airport transfers, corporate travel, private jet transfers, cruise port pickups & executive car hire. Book today." />
      </Helmet>
      <Banner />
      {/* <Booking /> */}
      <Services />
      {/* <AdditionalServices /> */}
      <WhatWeDo />

      <FleetV2 />
      {/* <Fleet /> */}
    </>
  )
}
export default Home
